<template>
  <div>
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>
    <div>
      <v-container fluid class="ma-0 pa-0 mt-6">
        <v-row dense>
          <v-col class="ma-0 pa-0">
            <v-card v-for="(item, index) in record" :key="index" flat >
              <v-card-title class="subtitle-1 font-weight-bold pa-0 justify-center">
                <div class="text-center mx-auto">
                  <div v-if="item.imagelink != 'N/A'" class="pic"><v-img :src="item.imagelink" contain></v-img></div>
                  <div v-if="item.imagelink == 'N/A'" class="pic"><label class="mx-auto text-center">No<br />Image<br />Available</label></div>
                  <div><barcode :value="item.capid" format="CODE39" :display-value="false" width="1" height="50" text-margin="0">
                    Could Not Render Barcode.
                  </barcode></div>
                  <div ><label class="title">{{item.rank + ' ' + item.namefirst + ' ' + (item.namemiddle == '' ? '':' ' + item.namemiddle + ' ') + item.namelast}}</label></div>
                </div>
              </v-card-title>
              <v-card-text class="ma-0 pa-0">
                  <v-container class="ma-0 pa-0 ">
                    <div v-if="selWing.toUpperCase() == 'CAWG' && (item.callsign!='' && item.callsign != null && item.callsign != undefined)">
                      <v-row no-gutters class="text-center mt-2 mb-2">
                          <v-col >
                              <label><span class="font-weight-bold  subtitle-1 light-blue--text text--darken-4">Yosemite {{item.callsign}}</span></label>
                          </v-col>
                      </v-row>
                    </div>
                    <v-row v-if="selWing.toUpperCase() == 'CAWG'" no-gutters class="text-center mt-2">
                        <v-col >
                            <label><span class="font-weight-bold red--text">DSW On File: </span><span class="font-weight-bold red--text">{{item.dsw == true ? 'YES':'NO'}}</span></label>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="text-center mt-2">
                        <v-col >
                            <label><span class="font-weight-bold">CAP DL: </span>{{item.capdl == true ? 'YES (Expires: ' + item.capdlexpiration +')':'NO'}}</label>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="text-center mb-4">
                        <v-col >
                            <label><span class="font-weight-bold">DL Types: </span>{{'(' + item.capdltypes + ')'}}</label>
                        </v-col>
                    </v-row>
                    <div class="text-center">
                      <div style="display: inline-block;" class="text-left">

                        <v-row no-gutters dense class="ma-0 pa-0">
                          <v-col class="text-left normalField">
                              <label><span class="font-weight-bold">CAPID: </span>{{item.capid}}</label>
                          </v-col>
                          <v-col class="text-left normalField">
                              <label><span class="font-weight-bold">Charter: </span>{{item.charternumber}}</label>
                          </v-col>

                        </v-row>
                        <v-row no-gutters dense class="ma-0 pa-0">

                          <v-col class="text-left normalField">
                              <label><span class="font-weight-bold">Height: </span>{{item.height}}</label>
                          </v-col>
                          <v-col class="text-left normalField">
                              <label><span class="font-weight-bold">Weight: </span>{{item.weight}}</label>
                          </v-col>

                        </v-row>
                        <v-row no-gutters dense class="ma-0 pa-0">

                          <v-col class="text-left normalField">
                              <label><span class="font-weight-bold">Eye Color: </span>{{item.eyes}}</label>
                          </v-col>
                          <v-col class="text-left normalField">
                              <label><span class="font-weight-bold">Hair Color: </span>{{item.hair}}</label>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-container>

                  <div class="text-center mb-4 mt-4">
                      <v-btn v-if="item.primarycellphone != 'N/A'" class="mx-2" fab dark small color="blue darken-4" :href="`tel:+1${item.primarycellphone}`">
                        <v-icon dark>mdi-phone</v-icon>
                      </v-btn>
                      <v-btn v-if="item.primaryhomephone != 'N/A'" class="mx-2" fab dark small color="green darken-4" :href="`tel:+1${item.primaryhomephone}`">
                        <v-icon dark>mdi-cellphone</v-icon>
                      </v-btn>
                      <v-btn class="mx-2" fab dark small color="orange darken-4" :href="`mailto:${item.email}`">
                        <v-icon dark>mdi-email</v-icon>
                      </v-btn>
                  </div>

                  <v-layout class="justify-center blue darken-4">
                    <div class="blue darken-4"><label><span class="font-weight-bold white--text">Emergency Services Ratings</span>&nbsp;</label></div>
                  </v-layout>

                  <v-container>
                    <div v-for="(skill) in skills" :key="skill.achid">
                      <v-row  no-gutters class="text-center">
                          <v-col cols="1" class="text-left ">
                              <label v-if="skill.setqualified == true"><v-icon color="black" x-small>mdi-cards-diamond</v-icon></label>
                              <label v-if="skill.doesnotexpire == true"><v-icon color="black" x-small>mdi-infinity</v-icon></label>
                              <label v-if="skill.training == true"><v-icon color="black" x-small>mdi-asterisk</v-icon></label>
                          </v-col>
                          <v-col  cols="11" class="text-left caption">
                              <label>{{skill.ach + (skill.doesnotexpire != true ? ' (Exp: ' + skill.expirationdate + ')' :'')}}</label>
                          </v-col>
                      </v-row>
                      <v-divider :key="item.achid"></v-divider>
                    </div>
                  </v-container>

                  <v-layout v-if="spectracks.length" class="justify-center blue darken-4">
                    <div class="blue darken-4"><label><span class="font-weight-bold white--text">Specialty Track Ratings</span>&nbsp;</label></div>
                  </v-layout>

                  <v-container v-if="spectracks.length">
                    <div v-for="(spectrack) in spectracks" :key="spectrack.track">
                      <v-row  no-gutters class="text-center">
                          <v-col cols="1" class="text-left ">
                              <label v-if="spectrack.level == 'TECHNICIAN'"><v-icon color="black" x-small>mdi-podium-bronze</v-icon></label>
                              <label v-if="spectrack.level == 'SENIOR'"><v-icon color="black" x-small>mdi-podium-silver</v-icon></label>
                              <label v-if="spectrack.level == 'MASTER'"><v-icon color="black" x-small>mdi-podium-gold</v-icon></label>
                          </v-col>
                          <v-col  cols="11" class="text-left caption">
                              <label>{{toProperCase(spectrack.track)}} ({{toProperCase(spectrack.level)}})</label>
                          </v-col>
                      </v-row>
                      <v-divider :key="item.achid"></v-divider>
                    </div>
                  </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- Begin - Loading Data Modal -->
    <v-dialog
      v-model="isLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Loading Data...
          <v-progress-linear
            indeterminate
            rounded
            color="white"
            class="mb-0"
            height="20px"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End - Loading Data Modal -->

  </div>     
</template>

<script>

import VueBarcode from 'vue-barcode';

export default {
  name: 'MemberInfoDetail',
  props: {
    capid: {
      type: String,
      default: null
    },
    emailaddress: {
      type: String,
      default: null
    }
  },
  components: {
    'barcode': VueBarcode
  },
  data() {
    return {
      isLoading: false,
      httpResponse:'',
      record: [],
      skills: [],
      spectracks: [],
      tempCapid: ''
    }
  },
  mounted() {
    this.getCapid();
    this.setBackButtonVisibility(true);
    this.setHomeButtonVisibility(true);
  },
  methods: {
    getCapid() {

      this.isLoading = true;

      if(this.emailaddress != null)
      {

        var localEmail = ""

        switch (this.emailaddress)
        {
          case 'john.consumer@hiwgcap.org':
            localEmail = 'harold.arnold@hiwgcap.org';
            break;
          case 'john.consumer@orwgcap.org':
            localEmail = 'brian.bishop@orwg.cap.gov';
            break;
          case 'john.consumer@nvwgcap.org':
            localEmail = 'dustin.surwill@nvwg.cap.gov';
            break
          default:
            localEmail = this.emailaddress;
            break
        }

        var upn = {
          wing: this.selWing,
          upn: localEmail
        }

        this.$https.post(this.$vars.BaseUrl + this.$vars.GetCapidFromUpnRoute, upn, this.$vars.config)
        .then(response => {

          this.getData(response.data);

        })
        .catch(e => {
          console.log(e);
          this.isLoading = false;
        });
      }
      else
      {
        this.getData(this.capid);
      }

    },
    getData(tcapid) {

      this.isLoading = true;

      var obj = {
        wing: this.selWing,
        capid: tcapid.toString()
      }

      this.$https.post(this.$vars.BaseUrl + this.$vars.GetMemberInfoCapidRoute, obj, this.$vars.config)
        .then(response => {
          this.httpResponse = response;
          this.record = response.data;
        })
        .catch(e => {
          console.log(e);
          this.isLoading = false;
        });

      this.$https.post(this.$vars.BaseUrl + this.$vars.GetMemberSkillsRoute, obj, this.$vars.config)
        .then(response => {
          this.httpResponse = response;
          this.skills = response.data;
        })
        .catch(e => {
          console.log(e);
          this.isLoading = false;
        });

        if (this.menuperms.Menu_SpecialtyTracks.includes(this.selWing.toUpperCase())) {
          // only display specialty track ratings if the Spec Tracks module is available for the member's wing
          this.$https.post(this.$vars.BaseUrl + this.$vars.GetSpecTracksByMemberRoute, {wing: this.selWing, id: tcapid.toString()}, this.$vars.config)
          .then(response => {
            this.httpResponse = response;
            this.spectracks = response.data;
          })
          .catch(e => {
            console.log(e);
            this.isLoading = false;
          });
        }

        this.isLoading = false;
    },
    toProperCase(str) {
      str = str.toLowerCase().split(' ');
      for (var i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
      }
      return str.join(' ');
    }
  }
}
</script>

<style scoped>

.normalField {
  width:145px;
}

.pic {
  width: 120px;
  height: 120px;
  border: 1px;
  border-style: solid;
  display: flex;
  align-items: center;
  margin: auto;
}

.spacer {
  font-size:0px
}

</style>
